import { Schema as S } from "effect";

export const UpdateScheduleRequestSchema = S.Struct({
  // Required
  _id: S.String,
  // Optional fields for partial updates
  start: S.optional(S.String),
  end: S.optional(S.String),
  duration: S.optional(S.Number),
  calendar: S.optional(S.String),
  roomId: S.optional(S.String),
  patient: S.optional(S.String),
  scheduletype: S.optional(S.String),
  employee: S.optional(S.String),
  userDescr: S.optional(S.String),
  details: S.optional(S.String),
  // Check-in fields
  arrivalTime: S.optional(S.String),
  scheduled: S.optional(S.Number), // -2=unconfirmed, -1=no-show, 0=default, 1=in-progress, 2=completed
  // Other optional fields
  severity: S.optional(S.String),
  urgency: S.optional(S.Number),
  adhoc: S.optional(S.Boolean),
});

export type UpdateScheduleRequest = S.Schema.Type<
  typeof UpdateScheduleRequestSchema
>;
